var map = {
	"./AUD.png": 717,
	"./BRL.png": 718,
	"./CAD.png": 719,
	"./CNY.png": 720,
	"./DKK.png": 721,
	"./EUR.png": 722,
	"./GBP.png": 723,
	"./HKD.png": 724,
	"./ILS.png": 725,
	"./INR.png": 726,
	"./JPY.png": 727,
	"./MXN.png": 728,
	"./MYR.png": 729,
	"./NOK.png": 730,
	"./NZD.png": 731,
	"./SEK.png": 732,
	"./SGD.png": 733,
	"./THB.png": 734,
	"./TRY.png": 735,
	"./USD.png": 736,
	"./ZAR.png": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 716;